import { useSyncExternalStore } from 'react';

/** Subscribe to a CSS media query. SSR-safe default: false. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => { list.removeEventListener('change', onChange); };
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Below this the shell uses a mobile header + navigation drawer (parity §1: desktop starts at 768px). */
export const MOBILE_QUERY = '(max-width: 767px)';
/** Below this the desktop sidebar is forced to the icon rail (prototype: 900px). */
export const NARROW_QUERY = '(max-width: 899px)';
